module.exports = __webpack_public_path__ + "media/images/partner-alt-2-72ec5905ddac4ad58f517aa01cd56e81.png";